import axios from "axios";

// 验证短信链接是否有效
export const verifySmsUrl = (data) => {
  return axios({
    baseURL: "",
    url: `/api/xp-dragon-koi-boot/h5/v1/customer/sms-url/verify`,
    method: "post",
    data,
  });
};

// 发送验证码
export const sendVerifyCode = (data) => {
  return axios({
    baseURL: "",
    url: `/api/xp-dragon-koi-boot/h5/v1/customer/sendVerifyCode`,
    method: "post",
    data,
  });
};

// 校验验证码
export const validateVerifyCode = (data) => {
  return axios({
    baseURL: "",
    url: `/api/xp-dragon-koi-boot/h5/v1/customer/validateVerifyCode`,
    method: "post",
    data,
  });
};

// 提交文件
export const fileSubmit = (data) => {
  return axios({
    baseURL: "",
    url: `/api/xp-dragon-koi-boot/h5/v1/customer/file/upload`,
    method: "post",
    data,
  });
};

// 通用参数明细列表
export const queryCommonParam = (data) => {
  return axios({
    baseURL: "",
    url: `/api/xp-dragon-koi-boot/h5/v1/customer/get/commonParam`,
    method: "post",
    data
  });
};
